import { render, staticRenderFns } from "./Hostels.vue?vue&type=template&id=5cefb473"
import script from "./Hostels.vue?vue&type=script&lang=js"
export * from "./Hostels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports